$(function() {
    // Owl Carousel
    var owl = $(".owl-carousel");
    owl.owlCarousel({
      items: 3,
      margin: 10,
      loop: true,
      nav: true,
      navText: [""],
      dots: false,
      pagination: false,
      responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:2,
            nav:false
        },
        1000:{
            items:3,
            nav:true,
            loop:false
        }
    }
    });
  });

  function getWhatsAppLink2() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // For iOS devices
        return "https://api.whatsapp.com/send?phone=919930071388";
    } else if (window.innerWidth <= 800) {
        // For other mobile devices
        return "https://api.whatsapp.com/send?phone=919930071388";
    } else {
        // For desktop
        return "https://web.whatsapp.com/send?phone=919930071388";
    }
}


function getCallLink() {
    var phone = '+918080805895'; // Your phone number
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // For iOS devices
        return "tel:" + phone;
    } else if (window.innerWidth <= 800) {
        // For other mobile devices
        return "tel:" + phone;
    } else {
        // For desktop - Can modify to open a contact page or show a message
        // since direct calling might not be supported
        return "javascript:alert('Please call us at " + phone + "');";
    }
}

function getEmailLink() {
    var user = 'here';
    var domain = 'herringboneandsui.com';
    return "mailto:" + user + "@" + domain;
}

// Clear filters
document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(event) {
        // Check if the clicked element is the "Clear All Filters" button or an individual filter's close button.
        const isClearAllButton = event.target.closest('#sf-clear-all-filter');
        const isCloseTagButton = event.target.closest('.active-facets__button');

        // Handle the "Clear All Filters" functionality.
        if (isClearAllButton) {
            event.preventDefault();
            handleClearAll();
        } else if (isCloseTagButton) {
            // Handle individual filter tag close functionality.
            event.preventDefault();
            handleCloseTag(isCloseTagButton);
        }
    });

    function handleClearAll() {
        const checkboxes = document.querySelectorAll('#CollectionFiltersForm input[type="checkbox"]');
        const radioButtons = document.querySelectorAll('#CollectionFiltersForm input[type="radio"]');
        
        checkboxes.forEach(checkbox => checkbox.checked = false);
        radioButtons.forEach(radio => radio.checked = false);

        checkboxes.forEach(checkbox => checkbox.dispatchEvent(new Event('change', { bubbles: true })));
        radioButtons.forEach(radio => radio.dispatchEvent(new Event('change', { bubbles: true })));

        updateActiveFiltersClass();
    }

    function handleCloseTag(closeTagButton) {
        const filterValue = closeTagButton.textContent.trim();
        const correspondingCheckbox = document.querySelector(`#CollectionFiltersForm input[value="${filterValue}"]`);

        if (correspondingCheckbox) {
            correspondingCheckbox.checked = false;
            correspondingCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            updateActiveFiltersClass();
        }
    }

    function updateActiveFiltersClass() {
        const facetsSummaryElements = document.querySelectorAll('.facets__summary');

        facetsSummaryElements.forEach(summaryElement => {
            const relatedCheckboxes = summaryElement.parentNode.querySelectorAll('input[type="checkbox"]');
            const isAnyCheckboxChecked = Array.from(relatedCheckboxes).some(checkbox => checkbox.checked);

            if (isAnyCheckboxChecked) {
                summaryElement.classList.add('active-filters');  // Add 'active-filters' class for bold styling.
            } else {
                summaryElement.classList.remove('active-filters'); // Remove 'active-filters' class.
            }
        });
    }
});



// Colour swatches

document.addEventListener('DOMContentLoaded', function() {
    // Select all checkboxes that are for color filters.
    const colorCheckboxes = document.querySelectorAll('input[type="checkbox"][name^="filter.v.option.color"]');

    colorCheckboxes.forEach(function(checkbox) {
        // Create a class name from the checkbox value.
        const colorClassName = checkbox.value.toLowerCase().replace(/\s+/g, '-');

        // Assuming the 'colourName' div is directly following the checkbox in the markup.
        const colourDiv = checkbox.parentElement.querySelector('.colourName');

        if (colourDiv) {
            // Add the class to the 'colourName' div.
            colourDiv.classList.add(colorClassName);
        }
    });
});




//make filter title bold

document.addEventListener('DOMContentLoaded', function() {
    const filterSections = document.querySelectorAll('.facets__summary');

    // Function to check the state of filters and update the title class.
    function updateTitleClass(section) {
        // Find related input elements. Adjust the selector based on your actual structure.
        let inputs = section.parentNode.querySelectorAll('input[type="checkbox"], input[type="radio"]');

        // Check if any of the inputs are checked.
        let isActive = Array.from(inputs).some(input => input.checked);

        // Update the class based on whether any filters are active.
        if (isActive) {
            section.classList.add('active-filter-title');
        } else {
            section.classList.remove('active-filter-title');
        }
    }

    // Initialize the state and set up event listeners.
    filterSections.forEach(section => {
        updateTitleClass(section); // Initial check

        // Setup event listeners for the inputs.
        section.parentNode.querySelectorAll('input').forEach(input => {
            input.addEventListener('change', () => updateTitleClass(section));
        });
    });

    // Optional: If there's a "clear all" functionality, ensure it triggers the class update.
    const clearAllButton = document.getElementById('sf-clear-all-filter');
    if (clearAllButton) {
        clearAllButton.addEventListener('click', function() {
            setTimeout(() => {
                filterSections.forEach(section => updateTitleClass(section));
            }, 10); // Adjust timeout as necessary
        });
    }
});


  


  

  
  










  